import { observer } from "mobx-react";
import React from "react";
import { IGuest } from "../../models/base/Guest";
import styles from "./calendarCell.css";

interface Props {
  guest?: IGuest;
}

export const CalendarCellMeetingClient = observer(({ guest }: Props) => {
  return <div className={styles["meeting-client"]}>{guest && guest.displayName}</div>;
});
